(function () {
  function getSectionRoot(el) {
    return el.closest('[data-section-id]') || el.closest('[data-main-product]') || document;
  }

  function getVisibleQtyInput(sectionRoot) {
    return sectionRoot.querySelector(
      '#product-qty, [id^="product-qty-"], input.product-qty, input[name="quantity"], .js-qty__num, .js-qty-input, .product-qty input, .quantity input'
    );
  }

  function getHiddenQtyInputs(sectionRoot) {
    return sectionRoot.querySelectorAll('input.formQty');
  }

  function normalizeCartonQty(value) {
    var v = parseInt(value || 1, 10);
    if (!Number.isFinite(v) || v < 1) return 1;
    return v;
  }

  function setAllQty(sectionRoot, cartonQty, packSize, triggerChange) {
    var visibleInput = getVisibleQtyInput(sectionRoot);
    var hiddenInputs = getHiddenQtyInputs(sectionRoot);
    var bottleQty = cartonQty * packSize;

    if (visibleInput) {
      visibleInput.setAttribute('min', '1');
      visibleInput.setAttribute('step', '1');
      visibleInput.setAttribute('inputmode', 'numeric');
      visibleInput.value = String(cartonQty);
      visibleInput.setAttribute('value', String(cartonQty));

      if (triggerChange) {
        try {
          visibleInput.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) {}
      }
    }

    hiddenInputs.forEach(function (input) {
      input.value = String(bottleQty);
      input.setAttribute('value', String(bottleQty));
      input.setAttribute('data-pack-size', String(packSize));
    });

    refreshMinusState(sectionRoot, cartonQty);
  }

  function refreshMinusState(sectionRoot, currentCartonQty) {
    sectionRoot
      .querySelectorAll('.quantity-control-down, .js-qty__adjust--minus, [data-qty-decrease]')
      .forEach(function (btn) {
        btn.disabled = parseInt(currentCartonQty, 10) <= 1;
      });
  }

  function bindSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.__minQtyBound) return;

    var dataEl = sectionRoot.querySelector('.minqty-data');
    if (!dataEl) return;

    var packSize = parseInt(dataEl.getAttribute('data-min-qty') || '1', 10);
    if (!Number.isFinite(packSize) || packSize <= 1) return;

    var visibleInput = getVisibleQtyInput(sectionRoot);
    if (!visibleInput) return;

    var startQty = normalizeCartonQty(visibleInput.value);
    setAllQty(sectionRoot, startQty, packSize, false);

    sectionRoot
      .querySelectorAll('.quantity-control-up, .js-qty__adjust--plus, [data-qty-increase]')
      .forEach(function (btn) {
        if (btn.__minQtyBound) return;
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var current = normalizeCartonQty(visibleInput.value);
            var next = current + 1;
            setAllQty(sectionRoot, next, packSize, true);
          },
          true
        );
        btn.__minQtyBound = true;
      });

    sectionRoot
      .querySelectorAll('.quantity-control-down, .js-qty__adjust--minus, [data-qty-decrease]')
      .forEach(function (btn) {
        if (btn.__minQtyBound) return;
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var current = normalizeCartonQty(visibleInput.value);
            var next = Math.max(1, current - 1);
            setAllQty(sectionRoot, next, packSize, true);
          },
          true
        );
        btn.__minQtyBound = true;
      });

    if (!visibleInput.__minQtyInputBound) {
      visibleInput.addEventListener('change', function () {
        var normalized = normalizeCartonQty(visibleInput.value);
        setAllQty(sectionRoot, normalized, packSize, false);
      });

      visibleInput.addEventListener('blur', function () {
        var normalized = normalizeCartonQty(visibleInput.value);
        setAllQty(sectionRoot, normalized, packSize, false);
      });

      visibleInput.__minQtyInputBound = true;
    }

    sectionRoot.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.__minQtySubmitBound) return;
      form.addEventListener(
        'submit',
        function () {
          var normalized = normalizeCartonQty(visibleInput.value);
          setAllQty(sectionRoot, normalized, packSize, false);
        },
        true
      );
      form.__minQtySubmitBound = true;
    });

    sectionRoot.__minQtyBound = true;
  }

  function initAll() {
    document.querySelectorAll('.minqty-data').forEach(function (el) {
      bindSection(getSectionRoot(el));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
    setTimeout(initAll, 250);
    setTimeout(initAll, 800);
  });

  new MutationObserver(function () {
    initAll();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();